// @ts-nocheck
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { getProductsDataView } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import displayProducts, {
    chain,
    RemoveNotAvailableAttributeValues,
    SetExpandTokens,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import removeProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/RemoveProductFilters";
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";
import qs from "qs";

replaceInChain(chain, SetExpandTokens, props => {
    SetExpandTokens(props);
    props.expandTokens?.push("properties");
});

replaceInChain(chain, RemoveNotAvailableAttributeValues, props => {
    const productsDataView = getProductsDataView(props.getState(), props.apiParameter);
    if (!productsDataView.value) {
        return;
    }

    const possibleAttributeValueIds = new Set();
    productsDataView?.attributeTypeFacets?.forEach(a =>
        a.attributeValueFacets?.forEach(v => possibleAttributeValueIds.add(v.attributeValueId)),
    );
    const removedAttributeValueIds = props.result.productFilters.attributeValueIds?.filter(
        o => !possibleAttributeValueIds.has(o),
    );
    if (removedAttributeValueIds?.length) {
        const attributeValueIds = props.result.productFilters.attributeValueIds?.filter(o =>
            possibleAttributeValueIds.has(o),
        );
        props.dispatch(removeProductFilters({ attributeValueIds: removedAttributeValueIds }));
        const parsedQuery = parseQueryString<any>(props.parameter.queryString);
        parsedQuery.attributeValueIds = attributeValueIds?.length ? attributeValueIds?.join(",") : undefined; // Greif
        const parameter = { ...props.parameter, queryString: qs.stringify(parsedQuery) };
        props.dispatch(displayProducts(parameter));
        return false;
    }
});
